import ENUMS from '../enums/productRegistryEnums';

export function hideRegistriesFromWishlist(payload, meta) {
    return {
        type: ENUMS.HIDE_REGISTRIES_FROM_WISHLIST,
        meta,
        payload: {
            showProductRegistries: false
        }
    };
}

export function resetAddToRegistry(component) {
    return {
        type: ENUMS.RESET_ADD_TO_REGISTRY,
        meta: {
            component: component
        }
    };
}

export function setProductRegistryVersion(registryVersion) {
    return {
        type: ENUMS.SET_PRODUCT_REGISTRY_VERSION,
        meta: {
        },
        payload: registryVersion
    };
}
